module.exports = __webpack_public_path__ + "img/phone.c91eea78.svg";